module.exports = __webpack_public_path__ + "assets/img/swiper-demo.bdf15274.png";